import React, { useState } from 'react';
import './adminlog.css';
import { useNavigate } from 'react-router-dom';

const AdminPage = () => {
  const [email, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
   
    const user = { email, password };
  
    try {
      const response = await fetch('http://localhost:3002/loginadmin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(user),
      });
  
      if (response.status === 200) {
        alert('Login successful');
    
        const timer = setTimeout(() => {
     
          navigate('/admin');
        }, 3000);
  
        return () => clearTimeout(timer);
      } else if (response.status === 400) {
        alert(''); 
      } else {
        alert('Incorrect email or password');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Server error');
    }
  };
  
  return (
    <div className="login-container">
      <div className="login-card">
        <h2 className="login-title">Admin</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={email}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="login-button">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminPage;